var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColleges4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.27 21.663c0 11.873-9.626 21.5-21.5 21.5-11.873 0-21.495-9.627-21.495-21.5s9.627-21.5 21.5-21.5 21.5 9.627 21.5 21.5h-.005Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 21.663c0 11.873-9.626 21.5-21.5 21.5-11.873 0-21.495-9.627-21.495-21.5s9.627-21.5 21.5-21.5 21.5 9.627 21.5 21.5h-.005Z",
    fill: "#FF8000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 21.663v-2h-2v2h2Zm.005 0v2h2v-2h-2Zm-2.005 0c0 10.769-8.73 19.5-19.5 19.5v4c12.978 0 23.5-10.522 23.5-23.5h-4Zm-19.5 19.5c-10.768 0-19.495-8.73-19.495-19.5h-4c0 12.978 10.517 23.5 23.495 23.5v-4Zm-19.495-19.5c0-10.769 8.731-19.5 19.5-19.5v-4c-12.978 0-23.5 10.522-23.5 23.5h4Zm19.5-19.5c10.769 0 19.5 8.731 19.5 19.5h4c0-12.978-10.522-23.5-23.5-23.5v4Zm21.5 17.5h-.005v4h.005v-4Z",
    fill: "#222",
    mask: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.373 28.235h2.53c.269 0 .485.216.485.486v4.127c0 .269-.216.485-.486.485h-2.529a.484.484 0 0 1-.485-.485V28.72c0-.27.216-.486.485-.486ZM28.895 28.235h2.529c.269 0 .485.216.485.486v4.127c0 .269-.216.485-.485.485h-2.53a.484.484 0 0 1-.485-.485V28.72c0-.27.216-.486.486-.486Z",
    fill: "#5B575E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m31.282 20.705-.251-.415 2.114-1.27v-4.33l-2.088-.954.203-.442 2.37 1.082v4.917l-2.348 1.412Z",
    fill: "#665C7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.041 14.848h-1.315a.406.406 0 0 0-.406.406v3.09c0 .224.181.406.406.406h1.315a.406.406 0 0 0 .406-.406v-3.09a.406.406 0 0 0-.406-.406Z",
    fill: "#534B64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.568 20.705-2.344-1.412v-4.917l2.37-1.082.203.442-2.088.953v4.33l2.11 1.271-.251.415Z",
    fill: "#665C7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.124 14.848H9.809a.406.406 0 0 0-.406.406v3.09c0 .224.181.406.406.406h1.315a.406.406 0 0 0 .406-.406v-3.09a.406.406 0 0 0-.406-.406Z",
    fill: "#534B64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.534 13.515H12.272v10.677h19.262V13.515Z",
    fill: "#F5B510"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.669 20.794H13.128v9.383h17.54v-9.383Z",
    fill: "#FAC911"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.995 22.656v7.517h-3.73v-7.517a1.863 1.863 0 0 1 3.183-1.315c.34.335.547.803.547 1.315ZM32.536 22.656v7.517h-3.73v-7.517a1.863 1.863 0 0 1 3.183-1.315c.34.335.547.803.547 1.315Z",
    fill: "#F8E618"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.128 21.606a1.841 1.841 0 0 0-.317 1.046v7.517h-.932v-6.802c0-.812.521-1.505 1.25-1.761Z",
    fill: "#EBDF9F",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.776 29.233a.971.971 0 0 1-.97.97h-21.81a.974.974 0 0 1-.97-.97.969.969 0 0 1 .967-.971H32.8c.538 0 .97.437.97.97h.005Z",
    fill: "#7DCDCE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.53 13.515c0 1.593-4.313 2.887-9.632 2.887-5.318 0-9.63-1.294-9.63-2.887s4.312-2.887 9.63-2.887c5.32 0 9.631 1.294 9.631 2.887Z",
    fill: "#F5B510"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.368 22.921a1.241 1.241 0 0 1-2.48 0 1.241 1.241 0 0 1 2.48 0Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.006 25.322a.874.874 0 0 1-.878.874.873.873 0 0 1-.874-.874.88.88 0 0 1 .874-.878.88.88 0 0 1 .878.878ZM31.547 25.322a.874.874 0 0 1-.878.874.873.873 0 0 1-.874-.874.88.88 0 0 1 .874-.878.88.88 0 0 1 .878.878Z",
    fill: "#F88011"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.913 22.921a1.241 1.241 0 0 1-2.48 0 1.241 1.241 0 0 1 2.48 0Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.535 22.652H16.266v4.581h11.269v-4.581Z",
    fill: "#E3BF14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.535 22.652v4.581h-.715v-3.866H16.266v-.715h11.269Z",
    fill: "#EBDF9F",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.254 15.223h-7.698V19.7h7.698v-4.476ZM30.342 15.223h-7.71V19.7h7.71v-4.476Z",
    fill: "#4AB2AC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M30.333 15.223V19.7l-7.697-4.476h7.697ZM21.254 15.223V19.7l-7.698-4.476h7.698Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.171 12.34h-8.536V14h8.536v-1.66Z",
    fill: "#FCFCFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 29.489h-7.075v1.818h7.075V29.49Z",
    fill: "#E5E5E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColleges4);
export default __webpack_public_path__ + "static/media/colleges 4.7b1161b77b452447e32e2691b835bc4d.svg";
export { ForwardRef as ReactComponent };